import {action, makeAutoObservable, observable} from "mobx";
import CommonStore from "../../../stores/CommonStore";
import {ProductOrderStatusHistoryService} from "../../../service/ProductOrderStatusHistoryService";
import ProductOrderStatusHistory from "../../../entities/ProductOrderStatusHistory";
import Trace from "../../../entities/Trace";
import { TraceService } from "../../../service/TraceService";
import ProductOrderTimelineItem from "../../../model/productOrderTimeline/ProductOrderTimelineItem";

class ShowProductOrderTimelineStore {

    public orderId: string;
    public loading: boolean;
    public commonStore: CommonStore;
    public statusHistory: ProductOrderStatusHistory[];
    public traces: Trace[];
    public timelineItems: ProductOrderTimelineItem[];

    public isRootAgency: boolean;

    constructor(commonStore: CommonStore, orderId: string, isRootAgency: boolean, hasTraceAccess: boolean) {
        this.orderId = orderId;
        this.loading = false;
        this.commonStore = commonStore;
        this.isRootAgency = isRootAgency;
        this.statusHistory = [];
        this.traces = [];
        this.timelineItems = [];
        this.loadTimeline(hasTraceAccess);
        makeAutoObservable(this, {
            statusHistory: observable,
            traces: observable,
        });
    }

    @action
    public async loadTimeline(hasTraceAccess: boolean): Promise<void> {
        this.commonStore.setLoading();

        try {
            const [statusHistory, traces] = hasTraceAccess ? await Promise.all([
                ProductOrderStatusHistoryService.getStatusHistory(this.isRootAgency, this.orderId),
                TraceService.get(this.orderId)
            ]) : await Promise.all([
                ProductOrderStatusHistoryService.getStatusHistory(this.isRootAgency, this.orderId),
            ]);

            this.statusHistory = statusHistory;
            this.traces = traces ?? [];

            const statusItems = statusHistory.map((status: ProductOrderStatusHistory) => new ProductOrderTimelineItem(
                status.id,
                'STATUS',
                status.date,
                '',
                status.comment,
                status.userName
            ));

            const traceItems = traces?.map((trace: Trace) => new ProductOrderTimelineItem(
                trace.id,
                'TRACE',
                trace.createdAt,
                this.getTraceDisplayName(trace.type),
                trace.description,
                trace.userName
            )) ?? [];

            this.timelineItems = [...statusItems, ...traceItems].sort((a, b) => b.date - a.date);
        } finally {
            this.commonStore.removeLoading();
        }
    }


    // @action
    // public async getStatusHistory(): Promise<void> {
    //     this.commonStore.setLoading();
    //     const response = await ProductOrderStatusHistoryService.getStatusHistory(this.isRootAgency, this.orderId);
    //     this.statusHistory = response;
    //     this.commonStore.removeLoading();
    // }

    // @action
    // public async getTraces(): Promise<void> {
    //     this.commonStore.setLoading();
    //     const response = await TraceService.get(this.orderId);
    //     this.traces = response;
    //     this.commonStore.removeLoading();
    // }

    get isEmpty(): boolean {
        return this.statusHistory.length === 0;
    }

     private getTraceDisplayName(type: string): string {
        switch (type) {
            case 'PRODUCT_ORDER_CREATED_TRACE':
                return 'PRODUCT_ORDER_CREATED_TRACE';
            default:
                return '';
        }
    }
}

export default ShowProductOrderTimelineStore;